{
  "page_count": "із {n, plural, one{# сторінки} other{# стор.}}"
}
